import React from 'react';
import ImportarArquivosPage from '../../../components/importacoes/ImportarArquivosPage';

export default function ImportarGuias() {
    return (
        <ImportarArquivosPage
            title="Importação de guias"
            subtitle="Processe as guias fiscais dos clientes de forma automatizada."
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Obrigações', to: '/obrigacoes' }, { label: 'Importar guias' }]}
            endpoint="guias/importar"
            formField="guias"
            uploadTitle="Envie o arquivo compactado das guias"
            uploadDescription="Selecione o arquivo .zip que contém as guias fiscais desejadas."
        />
    );
}
